import { useDocumentTitle } from "../../../use-document-title";
import { WorkflowRunsTable } from "./runs-table";
import { WorkflowSummaryCards } from "./summary-cards";
import styles from "./index.module.css";

/**
 * `/admin/workflows` dashboard route: the top summary-cards row (active
 * runs, workflows, scheduled workflows, infra schedules — see
 * `./summary-cards.tsx`) over the full-width runs table (`./runs-table.tsx`),
 * inside this app's ambient page padding. This page has real custom content
 * (not the generic placeholder shape), so it does not use `<StubPage>`. All
 * data rendered by its children is static mock content — there is no live
 * workflow-orchestration backend in `platform` yet.
 */
export function AdminWorkflowsPage() {
  useDocumentTitle("Workflows");

  return (
    <div className={styles.page}>
      <WorkflowSummaryCards />
      <WorkflowRunsTable />
    </div>
  );
}
